import React from 'react';
import { TextFieldProps, FilledTextFieldProps, ButtonProps, OutlinedTextFieldProps, StandardTextFieldProps } from "@material-ui/core";
import { ReactElement } from "react";

import SendIcon from '@material-ui/icons/Send';

export interface AlmeInputConfig {
    input: {
        maxInputLength: number;
        /**
         * Optional - remove for simple "send" icon
         */
        submitButtonText?: string;
        userTypingEventDelay?: number;
        styles: {
            textField: {
                color: TextFieldProps['color'];
                variant: FilledTextFieldProps['variant'] | OutlinedTextFieldProps['variant'] | StandardTextFieldProps['variant'];
                size: TextFieldProps['size'];
            };
            button: {
                color: ButtonProps['color'];
            };
        };
        shouldAutoFocus?: boolean;
        sendIcon?: ReactElement;
        displayError?: boolean;
    };
}

/**
 * This is the baseline input config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeInputConfig = {
    input: {
        //submitButtonText: 'Send',
        maxInputLength: 200,
        userTypingEventDelay: 10000,
        styles: {
            textField: {
                color: 'secondary' as const,
                variant: 'outlined' as const,
                size: 'medium' as const,
            },
            button: {
                color: 'secondary' as const,
            },
        },
        sendIcon: (<SendIcon />),
        displayError: true,
    },
};

export default defaultConfig;
